
import { supabase } from './supabaseClient';
import { Insumo, UnidadeMedida } from '../types';

export const insumosService = {
  async getInsumos(empresaId: string): Promise<Insumo[]> {
    const { data, error } = await supabase
      .from('insumos')
      .select('*, unidade_medida:unidades_medida(*)')
      .eq('empresa_id', empresaId)
      .order('nome', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  async getUnidadesMedida(): Promise<UnidadeMedida[]> {
    const { data, error } = await supabase
      .from('unidades_medida')
      .select('*')
      .order('nome', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  async salvarInsumo(insumo: Partial<Insumo>): Promise<Insumo> {
    const { data, error } = await supabase
      .from('insumos')
      .upsert(insumo)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async salvarUnidadeMedida(unidade: Partial<UnidadeMedida>): Promise<UnidadeMedida> {
    const { data, error } = await supabase
      .from('unidades_medida')
      .upsert(unidade)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async deletarInsumo(id: string): Promise<void> {
    const { error } = await supabase
      .from('insumos')
      .delete()
      .eq('id', id);

    if (error) throw error;
  },

  async movimentarEstoque(p_insumo_id: string, p_quantidade: number, p_tipo: string, p_motivo: string): Promise<void> {
    const { error } = await supabase.rpc('movimentar_estoque', {
      p_insumo_id,
      p_quantidade,
      p_tipo,
      p_motivo
    });

    if (error) throw error;
  }
};
